import axios from 'axios';
// 生产系统首页


const timestatus = (data) => axios.get('/pro/conf/list', data);
const recentorder = (data) => axios.get('/pro/lately/list', data);//最近订单
const hint = (data) => axios.get('/pro/notify/list', data);//生产提示
const capacity = (data) => axios.get('/pro/capacity/list', data);//产能趋势
const schedule = (data) => axios.get('/pro/orderLine/list', data);//订单进度
const autoline = (data) => axios.get('/pro/beltLine/list', data);//自动化生产线
const tendency = (data) => axios.get('/pro/energy/list', data);//单位产品能耗趋势
const yields = (data) => axios.get('/custom/rate/list', data);//产品良品率
const production = (data) => axios.get('/pro/quarter/list', data);//季度产量
const load = (data) => axios.get('/pro/load/list', data);

export default {
  timestatus,
  recentorder,
  hint,
  capacity,
  schedule,
  autoline,
  tendency,
  yields,
  production,
  load,
}
